import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=1980214c&scoped=true"
import script from "./RegisterResult.vue?vue&type=script&lang=js"
export * from "./RegisterResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980214c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1980214c')) {
      api.createRecord('1980214c', component.options)
    } else {
      api.reload('1980214c', component.options)
    }
    module.hot.accept("./RegisterResult.vue?vue&type=template&id=1980214c&scoped=true", function () {
      api.rerender('1980214c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/RegisterResult.vue"
export default component.exports